import React from 'react'
import PropTypes from 'prop-types'

const Title = props => {
  return (
    <div className='col-12 py-3 px-3 mx-0  border-color-ui-3 border-bottom'>
      <h3 className='color-title txt-font-body'>Pedido: #{props.orderId}</h3>
    </div>
  )
}

Title.propTypes = {
  orderId: PropTypes.number
}

export default Title



// WEBPACK FOOTER //
// ./src/Participant/MyOrders/ProductOrderDetail/ProductSide/Title.js